









import {
  Vue,
  Component,
  Prop
} from "vue-property-decorator";

import HomePageService from '../home-page/HomePageService'

@Component({
  components: {},
})
export default class NoticeView extends Vue {
  @Prop()
  public noticeId!:string;
  @Prop()
  public visible!: boolean;

  public title : string = '';

  public content: string = '';
  public fileupload: string = '';
  public data: any = {};

  public open() {
    //@ts-ignore
    const user:any=JSON.parse(localStorage.getItem('user'))
    HomePageService.getNoticeDetail(this.noticeId).then(res => {
      if(res && res.data) {
        try {
          this.$http.post(`/cssmobileplatformapi/appapi/noticeRead`,{
            mpNoticeId:res.data.mpnoticeid,
            userCode:user.userCode
            })
        } catch (error) {
        }

        const data = res.data;
        this.data = res.data
        this.title = data.noticename;
        this.content = data.noticecontent;
        this.fileupload = data.fileupload
      }
    })
  }
  public closed (){
    this.title = '';
    this.content = '';
    this.$emit('closed')
  }
}
